import React from 'react';

import Tooltip from 'components/tooltip';
import { Card } from 'react-bootstrap-5';

interface Props {
  children?: React.ReactNode;
  header: string;
  path: string;
  subheader?: string;
  target?: '_blank';
}

export default function Association({ children, header, path, subheader, target }: Props) {
  return (
    <a className="text-decoration-none" href={path} target={target}>
      <Card className="mb-1 bg-light crm-association__card">
        <Card.Body>
          <div className="d-flex flex-column">
            <Tooltip content={header} dark onlyOnOverflow>
              <div className="fs-large fw-bold">{header}</div>
            </Tooltip>

            {subheader &&
              <span className="text-muted text-truncate">{subheader}</span>
            }
          </div>

          {children &&
            <div className="d-flex flex-row text-muted">
              {children}
            </div>
          }
        </Card.Body>
      </Card>
    </a>
  );
}
